import DateFormatter from 'common/utils/DateFormatter';
import toast from 'common/utils/toast';
import { isLocalhost } from './helper';

const md5 = require('md5');
const SparkMD5 = require('spark-md5');
const UAParser = require('ua-parser-js');
const JSZip = require('jszip')
const BASE_CALENDAR_URL = 'https://calendar.google.com/calendar/render?action=TEMPLATE'

const LANGUAGES = [
   { name: 'English', value: 'en', english_name: 'English' },
   { name: 'Русский', value: 'ru', english_name: 'Russian' },
   { name: 'Italiano', value: 'it', english_name: 'Italian' },
   { name: 'Français', value: 'fr', english_name: 'French' },
   { name: '中國人', value: 'zh-CN', english_name: 'Chinese' },
   { name: 'Dutch', value: 'nl', english_name: 'Dutch' },
   { name: 'Deutsch', value: 'de', english_name: 'German' },
   { name: 'Português', value: 'pt', english_name: 'Portuguese' },
   { name: 'Polskie', value: 'pl', english_name: 'Polish' },
   { name: '日本語', value: 'ja', english_name: 'Japanese' },
   { name: 'Español', value: 'es', english_name: 'Spanish' },
]

const trigerExportCsvClick = (href) => {
   const a = window.document.createElement('a');
   a.href = href;
   document.body.appendChild(a);
   a.click();
   document.body.removeChild(a);
};

const copyText = (text) => {
   var el = document.createElement('textarea');
   el.value = text;
   el.setAttribute('readonly', '');
   el.style = { position: 'absolute', left: '-9999px' };
   document.body.appendChild(el);

   if(navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      var editable = el.contentEditable;
      var readOnly = el.readOnly;

      el.contentEditable = true;
      el.readOnly = true;

      var range = document.createRange();
      range.selectNodeContents(el);


      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      el.setSelectionRange(0, 999999);


      el.contentEditable = editable;
      el.readOnly = readOnly;
   } else {
      el.select();
   }

   try {
      const successful = document.execCommand('copy');
      console.log(successful, 'successful')
      if(successful) {
         console.log('Text copied to clipboard');
      } else {
         console.error('Failed to copy text');
      }
   } catch (err) {
      console.error('Error copying text:', err);
   }
   // document.execCommand('copy');
   document.body.removeChild(el);
};
const quillUtils = () => {
   const keys = {
      'backspace': 8,
      'shift': 16,
      'ctrl': 17,
      'alt': 18,
      'delete': 46,
      // 'cmd':
      'leftArrow': 37,
      'upArrow': 38,
      'rightArrow': 39,
      'downArrow': 40,
   }
   let utils = {
      special: {},
      navigational: {},
      isSpecial(e) {
         return typeof this.special[e.keyCode] !== 'undefined';
      },
      isNavigational(e) {
         return typeof this.navigational[e.keyCode] !== 'undefined';
      },
      isSelect(e) {
         return e.keyCode === 65 && e.ctrlKey // ctrl+a
      },
   }

   utils.special[keys['backspace']] = true;
   utils.special[keys['shift']] = true;
   utils.special[keys['ctrl']] = true;
   utils.special[keys['alt']] = true;
   utils.special[keys['delete']] = true;

   utils.navigational[keys['upArrow']] = true;
   utils.navigational[keys['downArrow']] = true;
   utils.navigational[keys['leftArrow']] = true;
   utils.navigational[keys['rightArrow']] = true;
   return utils;
};

const formatApiErrors = (errors) => {
   const result = {};
   Object.keys(errors).forEach(key => {
      if(errors[key] && errors[key][0]) {
         result[key] = errors[key][0];
      }
   });
   return result;
}

const getBase64FromImageFile = (file) => {
   return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = function(event) {
         return resolve(event.target.result);
      };
      reader.readAsDataURL(file);
   });
}

const getObjectMd5 = (obj) => {
   let stringKey = '';
   const keys = Object.keys(obj).sort();
   keys.forEach((val) => {
      stringKey += String(obj[val]);
   });
   return md5(stringKey);
}

const isMobileAndTablet = function() {
   var check = false;
   // eslint-disable-next-line no-useless-escape
   (function(a){ if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
   return check;
}

const makeRandomString = (length) => {
   var text = "";
   var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

   for(var i = 0; i < length; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

   return text;
}
const downloadMediaFromUrl = async (url, isNewTab = false, fileName = 'download', ignoreRegex = false) => {
   try {
      let downloadFileUrl = url
      let downloadFileName = fileName
      if(downloadFileName !== 'download') {
         // eslint-disable-next-line no-useless-escape
         const regex = /\/([^\/?]+)\.(zip|pdf|rar|mp3|aac|wav|flac|alac|aiff)(?:\?|$)/i
         const match = downloadFileUrl.match(regex)

         if(!!match && !ignoreRegex) downloadFileName = `${ downloadFileName }.${ match[2] }`

         const response = await fetch(url)
         if(!response.ok) {
            throw new Error('Network response was not ok')
         }
         const blob = await response.blob()
         downloadFileUrl = URL.createObjectURL(blob)
      }

      const tag = document.createElement('a')
      tag.href = downloadFileUrl
      tag.download = downloadFileName
      if(isNewTab) {
         tag.target = '_blank'
      }
      document.body.appendChild(tag)
      tag.click()
      document.body.removeChild(tag)

      // Clean up the URL.createObjectURL reference to the blob
      URL.revokeObjectURL(downloadFileUrl)
   } catch (error) {
      console.error('Error downloading file:', error)
   }
}
function numberKFormatter(num) {
   return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num); // Exp 1.2K
}
const getCountState = (count, name, intCount, isKFormat = false) => {
   let number = count;
   if('string' === typeof count && 'number' === typeof intCount){
      number = intCount
   }
   let res = `${ count } ${ name }`
   if(number > 1 || number === 0){
      if(isKFormat){
         res = `${ numberKFormatter(count) } ${ name }s`;
      } else {
         res = `${ count } ${ name }${ !!name && !['mailing list'].includes(name) ? 's' : '' }`
      }
   }
   return res
}

const getImageFileHash = (file) => {
   const CHUCK_SIZE = 2097152;
   return new Promise((resolve, reject) => {
      let currentChunk = 0;
      const chunks = Math.ceil(file.size / CHUCK_SIZE);
      const blobSlice =
   File.prototype.slice ||
   File.prototype.mozSlice ||
   File.prototype.webkitSlice;
      const spark = new SparkMD5.ArrayBuffer();
      const fileReader = new FileReader();
      const loadNext = () => {
         const start = currentChunk * CHUCK_SIZE;
         const end =
     start + CHUCK_SIZE >= file.size ? file.size : start + CHUCK_SIZE;
            // Selectively read the file and only store part of it in memory.
            // This allows client-side applications to process huge files without the need for huge memory
         fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
      };
      fileReader.onload = e => {
         spark.append(e.target.result);
         currentChunk++;
         if(currentChunk < chunks) loadNext();
         else {
            const result = spark.end()
            resolve(result)
         }
      };
      fileReader.onerror = () => {
         return reject('Calculating file checksum failed');
      };
      loadNext();
   });
}
const getVideoFileHash = (file) => {
   const { name, lastModified, size } = file
   let hexHash = SparkMD5.hash(`${ name }${ lastModified }${ size }`);
   return hexHash
}


const makeTweetableUrl = (url, text) => {
   let tweetableText = `https://twitter.com/compose/tweet?&url=${ url }`;
   if(!!text) tweetableText += `&text=${ text }`
   return tweetableText;
}
const makeFbShareUrl = (url) => {
   let shareableText = `https://www.facebook.com/sharer/sharer.php?u=${ url }`;
   return shareableText;
}
const makeSnapShareUrl = (url) => {
   let shareableText = `https://www.snapchat.com/scan?attachmentUrl=${ url }`;
   return shareableText;
}
// const makeShareSomeShareUrl = (url) => {
//    let shareableText = `https://sharesome.com/post/?url=${ url }`;
//    return shareableText;
// }

const insertTextMac = (el, a, text) => {
   const oldContentEditable = el.contentEditable;
   const oldReadOnly = el.readOnly;
   const range = document.createRange();
   el.contentEditable = true;
   el.readOnly = false;
   range.selectNodeContents(el);

   const s = window.getSelection();
   s.removeAllRanges();
   s.addRange(range);

   el.setSelectionRange(a, a)
   el.contentEditable = oldContentEditable;
   el.readOnly = oldReadOnly;
   document.execCommand('insertText', false, text);
}

// add emoji
const getCurrentPosition = (elementRef) => {
   const oField = elementRef
   let iCaretPos = 0;
   if(document.selection) {
      oField.focus();
      let oSel = document.selection.createRange();
      oSel.moveStart('character', -oField.value.length);
      iCaretPos = oSel.text.length;
   }

   else if(oField.selectionStart || +oField.selectionStart === 0)
      iCaretPos = oField.selectionDirection === 'backward' ? oField.selectionStart : oField.selectionEnd;

   return iCaretPos;
}

const switchShowEmojis = async (elementRef, cursorPosition) => {
   const ctrl = elementRef
   let start = cursorPosition
   if(!start) {
      start = ctrl.value.length
   }
   if(ctrl != null) {
      if(ctrl.createTextRange) {
         let range = ctrl.createTextRange();
         range.move('character', start);
         range.select();
      }
      else {
         if(ctrl.selectionStart) {
            ctrl.focus();
            ctrl.setSelectionRange(start, start);
         }
         else
            ctrl.focus();
      }
   }

}
const addEmojiOnInput = (e, elementRef) => {
   const sym = e.unified.split('-');
   const codesArray = [];
   sym.forEach(el => codesArray.push(`0x${ el }`));
   const emojiPic = String.fromCodePoint(...codesArray);
   const el = elementRef;
   const selectionStart = el?.selectionStart;
   el.selectionStart = el.selectionEnd = selectionStart + emojiPic.length;

   const browserName = getBrowserName()

   switch (browserName) {
      case 'safari':
         insertTextMac(el, selectionStart, emojiPic)
         break;
      default:
         setTimeout(() => {
            window.document.execCommand('insertText', false, emojiPic);
         }, 0)
         break;
   }

   el.focus();
}
//

const onWrongPriceLength = (value, price) => {
   const charecter = 7;
   let maxCherecters = charecter;
   if(price < 10) {
      maxCherecters = 1;
   }
   if(value.includes('.')) {
      const test = value.split('.');
      maxCherecters = test[0].length + 3;

   }
   if(value.length > maxCherecters) {
      return true
   }
   return false
}

function getBrowserName(){

   let userAgent = navigator.userAgent;
   let browserName;

   if(userAgent.match(/chrome|chromium|crios/i)){
      browserName = 'chrome';
   } else if(userAgent.match(/firefox|fxios/i)){
      browserName = 'firefox';
   }  else if(userAgent.match(/safari/i)){
      browserName = 'safari';
   } else if(userAgent.match(/opr\//i)){
      browserName = 'opera';
   } else if(userAgent.match(/edg/i)){
      browserName = 'edge';
   } else {
      browserName = 'other';
   }
   return browserName
}


const getTopPercentage = (top, round = false) => {
   if(typeof top !== 'number') return null
   if(0 === top || 25 < top) return null
   if(top < 1 && top > 0) return '1';
   if(top > 1 && top < 2) {
      let res = top.toFixed(2)
      let arr = res.split('.')
      if(arr[1] === '00' && !Number.isInteger(top)){
         res = `${ arr[0] }.01`
      }
      return res;
   }
   if(round){
      return Math.round(top);
   }
   return top.toFixed();
}

const getSetDifference = (setA, setB) => {
   return new Set(
      [...setA].filter(element => !setB.has(element))
   );
}
const iosCopyToClipboard =  el => {
   if('safari' !== getBrowserName()){
      return
   }
   const oldContentEditable = el.contentEditable
   const oldReadOnly = el.readOnly
   const range = document.createRange();

   el.contentEditable = true;
   el.readOnly = false;
   range.selectNodeContents(el);

   const s = window.getSelection();
   s.removeAllRanges();
   s.addRange(range);

   el.setSelectionRange(0, 999999);

   el.contentEditable = oldContentEditable;
   el.readOnly = oldReadOnly;

   document.execCommand('copy');
};

const getProtocol = () => {
   let protocol = 'https://';
   const domain = process.env.REACT_APP_AMS_DOMAIN;
   if(domain && domain.includes('mms.loc')) {
      protocol = 'http://';
   }
   return protocol;
};
const getSiteDomain = () => {
   let domain = window.location.host.replace('dashboard.', '');
   if(process.env.REACT_APP_AMS_DOMAIN && process.env.REACT_APP_AMS_DOMAIN.includes('mms.loc')) {
      domain = process.env.REACT_APP_AMS_DOMAIN;
   }
   return domain;
};
const getLanguages = () => {
   return LANGUAGES;
};
const getCurrentLanguageByValue = (value, showEnglishName = false) => {
   let currentName = 'Select';
   if(value) {
      const current = LANGUAGES.find(i => i.value === value);
      if(current) {
         if(showEnglishName){
            currentName = current.english_name;
         } else {
            currentName = current.name;
         }
      }
   }
   return currentName;
}
const setCookieValue = (cookieName, cookieValue, expiryDate) => {
   const d = new Date();
   d.setTime(d.getTime() + (expiryDate * 24 * 60 * 60 * 1000));
   const expires = "expires=" + d.toUTCString();
   document.cookie = cookieName + "=" + cookieValue + "; " + expires + "; path=/";
}
const onTranslteLanguage = value => {
   const element = document.querySelector('#google_translate_element .goog-te-combo');
   if(element){
      element.value = value
      const evt = new Event('change');
      element.dispatchEvent(evt);
   }
}

const upperCaseFirstLetter =  str => {
   const result = str.charAt(0).toUpperCase() + str.slice(1);
   return result;
}

const getAllowedVideoExtentions = _ => {
   return [
      'video/mp4',
      'video/quicktime',
      'video/mpeg',
      'video/webm',
      'video/x-ms-wmv',
      'video/x-flv',
      'video/x-msvideo',
      'video/3gpp',
      'video/x-matroska',
      'video/avi',
      'video/m4v',
      'video/x-m4v',
   ]
}

const getAllowedVrVideoQualityOptionExtentions = _ => {
   return [
      'video/mp4',
   ]
}

const encodeString = (str) => {
   if(!Boolean(str)){
      return
   }
   const encoder = new TextEncoder();
   const data = encoder.encode(str);
   return btoa(String.fromCharCode(...new Uint8Array(data)));
}

const decodeString = (encoded) => {
   if(!Boolean(encoded)){
      return
   }
   const decodedData = atob(encoded).split("").map((c) => c.charCodeAt(0));
   const decoder = new TextDecoder();
   return decoder.decode(new Uint8Array(decodedData));
}

const toTitleCase = (str) => {
   const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i
   const alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/
   const wordSeparators = /([ :–—-])/

   return str.split(wordSeparators)
      .map(function(current, index, array) {
         if(
         /* Check for small words */
            current.search(smallWords) > -1 &&
        /* Skip first and last word */
        index !== 0 &&
        index !== array.length - 1 &&
        /* Ignore title end and subtitle start */
        array[index - 3] !== ':' &&
        array[index + 1] !== ':' &&
        /* Ignore small words that start a hyphenated phrase */
        (array[index + 1] !== '-' ||
          (array[index - 1] === '-' && array[index + 1] === '-'))
         ) {
            return current.toLowerCase()
         }

         /* Ignore intentional capitalization */
         if(current.substr(1).search(/[A-Z]|\../) > -1) {
            return current
         }

         /* Ignore URLs */
         if(array[index + 1] === ':' && array[index + 2] !== '') {
            return current
         }

         /* Capitalize the first letter */
         return current.replace(alphanumericPattern, function(match) {
            return match.toUpperCase()
         })
      })
      .join('')
}

// const addDynamicCode = (text, position) => {
//    try {
//       const rexExp = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;
//       const pattern = /<script\s+(.*?)>/;
//       const isHasScripy = pattern.test(text) || rexExp.test(text);
//       let newScript = null;
//       let parnet = null;
//       switch (position) {
//          case 'head':
//             parnet = document.head
//             break;
//          case 'body':
//             parnet = document.body
//             break;

//          default:
//             break;
//       }

//       if(!isHasScripy) {
//          newScript = document.createElement('script');
//          const inlineScript = document.createTextNode(text);
//          newScript.appendChild(inlineScript);
//          parnet.insertBefore(newScript, parnet.lastChild);
//          return
//       }

//       const container = document.createElement('div');
//       container.innerHTML = text;
//       const copyScript = container.childNodes || [];
//       window.copyScript = copyScript
//       for(let index = 0; index < copyScript.length; index++) {
//          const element = copyScript[index];
//          const nodeType = element?.nodeName ? element.nodeName.toLocaleLowerCase() : ''
//          if('script' === nodeType){
//             const  scriptContent = element.textContent;
//             const attributes = element.attributes;
//             newScript = document.createElement('script');
//             const inlineScript = document.createTextNode(scriptContent);
//             for(let i = 0; i < attributes.length; i++) {
//                const attribute = attributes[i];
//                const attributeName = attribute.name;
//                const attributeValue = attribute.value;
//                newScript.setAttribute(attributeName, attributeValue)
//             }
//             newScript.appendChild(inlineScript);
//             parnet.insertBefore(newScript, parnet.lastChild);
//          } else {
//             if(nodeType.includes('comment')){
//                parnet.insertBefore(element, parnet.lastChild);
//             }
//          }
//       }
//       return

//    } catch (error) {
//       console.log(error)
//    }

// }
function stringToElements(htmlString) {
   const template = document.createElement('div');
   template.innerHTML = htmlString.trim();
   const elements = template.children || [];
   return elements;
}
const addDynamicCode = (text, position) => {
   try {
      let parnet = null;
      switch (position) {
         case 'head':
            parnet = document.head
            break;
         case 'body':
            parnet = document.body
            break;

         default:
            break;
      }

      const elements = stringToElements(text);
      for(const key in elements) {
         if(Object.hasOwnProperty.call(elements, key)) {
            const element = elements[key];
            const nodeType = element?.nodeName ? element.nodeName.toLocaleLowerCase() : '';
            if('script' === nodeType){
               let newScript = null;
               const  scriptContent = element.textContent;
               const attributes = element.attributes;
               newScript = document.createElement('script');
               const inlineScript = document.createTextNode(scriptContent);
               for(let i = 0; i < attributes.length; i++) {
                  const attribute = attributes[i];
                  const attributeName = attribute.name;
                  const attributeValue = attribute.value;
                  newScript.setAttribute(attributeName, attributeValue)
               }
               newScript.appendChild(inlineScript);
               parnet.insertBefore(newScript, parnet.lastChild);

            } else {
               parnet.insertBefore(element, parnet.lastChild);
            }
         }
      }
   } catch (error) {
      console.log(error)
   }

}

const getDefaultNotificationSettings = (defaultSettings, slug) => {
   const autoTweet = defaultSettings?.auto_tweet
   const massPrivateMessage = defaultSettings?.mass_private_message
   let data = {
      tweet: {
         body: autoTweet?.body || '',
         isSwitch: autoTweet?.is_on || false,
      },
      notify_members: {
         isSwitch: massPrivateMessage?.is_on || false,
         subject: massPrivateMessage?.subject || '',
         body: massPrivateMessage?.body || '',
      },
   }
   return data;
}

const getVariablesValue = (info = {
   url: '', siteName: '', screenName: '', adminsState: '', contentLink: '', pageId: '', memberUsername: '',
}) => {
   const variablesValue = {
      '<I/we>': 'multiple' === info.adminsState ? 'we' : 'I',
      '<my/our>': 'multiple' === info.adminsState ? 'our' : 'my',
      '<I’m/we’re>': 'multiple' === info.adminsState ? 'we’re' : 'I’m',
      '<me/us>': 'multiple' === info.adminsState ? 'us' : 'me',
      '<I’ve/we’ve>': 'multiple' === info.adminsState ? 'we’ve' : 'I’ve',
      '<admin-screen-name>': info.screenName,
      '<link-of-content>': info.contentLink,
      '<site-name>': info.siteName,
      '%site-name%': info.siteName,
      '<site-long-name>': info.siteName,
      '<member-username>': info.memberUsername,
      '<site-link>': info.url,
   }

   return variablesValue;
}

const getFixedSentences = (siteInfo, description, homePageUrl) => {

   const variableList = getVariablesValue({
      siteName: siteInfo?.site_long_name,
      screenName: siteInfo?.admin_screen_name,
      adminsState: siteInfo?.single_or_multiple_admins,
      url: siteInfo?.url,
      memberUsername: siteInfo?.username,
   })
   const textarea = document.createElement('textarea')
   textarea.innerHTML = description

   let text = textarea.value

   if(text.includes('<site-link>')) {
      text = text.replaceAll('<site-link>', `<a class='site-link-variable' href='${ homePageUrl }'><site-link></a>`)
   }

   Object.keys(variableList).forEach(key => {
      text = text.replaceAll(key, variableList[key])
   })

   const keyWords = ['we', 'I', 'our', 'my', 'we’re', 'I’m', 'us', 'me', 'we’ve', 'I’ve']
   const newText = text.trim()
   let linksList = []

   function replaceWordAfterDot(text, wordToCheck) {
      const regex = new RegExp(`\\.\\s*(${ wordToCheck }\\b)`, 'gi');
      return text.replace(regex, (match, group) => {
         return match.replace(group, wordToCheck.charAt(0).toUpperCase() + wordToCheck.slice(1, wordToCheck.length));
      });
   }

   function replaceATags(text) {
      const regex = /<[^>]*>/g;

      return text.replace(regex, (match, href, innerText) => {
         let index = linksList?.length
         linksList.push(match)
         return 'replacedLink-' + index
      });
   }

   let withoutLinks = replaceATags(newText)

   const tag = document.createElement('p')
   tag.innerHTML = withoutLinks

   let result = tag.innerText

   keyWords.forEach(it => {
      result = replaceWordAfterDot(result, it);
   })

   if(linksList.length) {
      linksList.forEach((link, i) => {
         result = result.replace(`replacedLink-${ i }`, link)
      })
   }

   return result
}

const isQuillEmpty = (value) => {
   if(value.replace(/<(.|\n)*?>/g, '').trim().length === 0 && !value.includes("<ol") && !value.includes("<ul")) {
      return true;
   }
   return false;
}

const getProfileAccountState = (type) => {
   const STATE_BY_ACCOUNT_TYPE = {
      business: {
         address_title: 'Business address',
         placeholder_city: 'Enter city / town',
         placeholder_street: 'Enter street',
         placeholder_province_region: 'Enter state / province / region',
         placeholder_apartment: 'Enter apartment number',
         placeholder_zip_postal_code: 'Enter zip / postal code',
         placeholder_address: 'Enter address',
         placeholder_first_name: 'Enter first name',
         placeholder_last_name: 'Enter last name',
         placeholder_screen_name: 'Enter screen name',
         placeholder_greeting_name: 'Enter greeting name',
      },
      personal: {
         address_title: 'Personal address',
         placeholder_city: 'Enter your city / town',
         placeholder_street: 'Enter your street',
         placeholder_province_region: 'Enter your state / province / region',
         placeholder_apartment: 'Enter your apartment number',
         placeholder_zip_postal_code: 'Enter your zip / postal code',
         placeholder_address: 'Enter your address',
         placeholder_first_name: 'Enter your first name',
         placeholder_last_name: 'Enter your last name',
         placeholder_screen_name: 'Enter your screen name',
         placeholder_greeting_name: 'Enter your greeting name',
      },
   }
   return STATE_BY_ACCOUNT_TYPE?.[type] || {};
}

const parseUserAgent = (userAgent) => {
   const parser = new UAParser();
   parser.setUA(userAgent);
   const uaResult = parser.getResult();

   const browser = uaResult.browser.name || 'Unknown Browser';
   const browserVersion = uaResult.browser.version || 'Unknown Version';
   const os = uaResult.os.name || 'Unknown OS';
   // const osVersion = uaResult.os.version || 'Unknown Version';

   return `Browser: ${ browser } ${ browserVersion }, OS: ${ os }`;
}

const getAmazonPrefix = (url) => {
   let amazonPrefix = 'www.amazon';
   const urlPrefix = url ? url.slice(0, amazonPrefix.length) : '';
   if(amazonPrefix.includes(urlPrefix)) {
      return 'https://';
   } else {
      return 'https://www.amazon.com/wishlist/';
   }
}

const getMemberTotalSpent = (user, round = false) => {
   const result =  user?.total_spent_sum || user?.total_spent;
   if(round){
      return Math.round(result);
   }
   return result;
}

const getMyListUrl = () => {
   switch (true) {
      case process.env.REACT_APP_AMS_DOMAIN.includes('mms.loc'):
         return 'http://localhost:5173'

      case process.env.REACT_APP_AMS_DOMAIN.includes('amstest'):
         return 'https://staging.mylist.site'

      default:
         return 'https://mylist.site'
   }
}
const stripMetadataFromZip = async (file) => {
   const zip = new JSZip()
   try {
      await zip.loadAsync(file)

      const strippedZip = new JSZip();
      await Promise.all(Object.keys(zip.files).map(async (filename) => {
         const fileData = await zip.files[filename].async('uint8array')
         // Metadata stripping logic can be added here if needed
         strippedZip.file(filename, fileData)
      }))

      const strippedFile = await strippedZip.generateAsync({ type: 'blob' })
      return strippedFile

   } catch (error) {
      console.log(error)
      return file;
   }
};

const stripMetadata = async (file) => {
   if(file.type === 'application/zip') {
      return stripMetadataFromZip(file)
   } else {
      return file; // No metadata stripping for unsupported file types
   }
};
const generateCalendarUrl =  (title, description, date) => {
   const startDate = DateFormatter.convertToUserTz(date, 'YYYYMMDDTHHmmSSZ');
   let addedDate = DateFormatter.addDatev2(date, 3600);
   const endDate = DateFormatter.convertToUserTz(addedDate, 'YYYYMMDDTHHmmSSZ');
   let eventDate = `&dates=${ startDate }/${ endDate }`
   let text = `&text=${ title }`
   let details = `&details=${ description }`
   const url = BASE_CALENDAR_URL + eventDate + text  + details
   return url
};
const onClickAddToCalendar =  (title, description, date) => {
   const url = generateCalendarUrl(title, description, date);
   window.open(url, '', `width=${ window.innerWidth },height=${ window.innerHeight }`);
};
const converDesriptionVarables = (body, variableList) => {
   if(!body){
      return body;
   }
   if(!variableList?.length){
      return body;
   }
   variableList.forEach(item => {
      let variable = item.text;
      variable = variable.replace('<', '');
      variable = variable.replace('>', '');
      body = body?.replaceAll(`<${ variable }>`, `&lt;${ variable }&gt;`);
   })

   return body;
}
const getUserStatusType = (bool) => {
   let result = 'public'
   if(bool){
      result = 'active'
   }
   return result
};
const getPrimaryColor = (primaryColor, useMemberPrimary) => {
   let skinPrimaryColor = primaryColor || '#231FFF';

   if('undefined' !== typeof window && window.skinPrimaryColor){
      skinPrimaryColor =  window.skinPrimaryColor;
   }
   if('undefined' !== typeof window && window.memberPrimaryColor && useMemberPrimary){
      skinPrimaryColor =  window.memberPrimaryColor;
   }
   return skinPrimaryColor;
};
const isDarkSite = () => {
   let isDark = false;

   if('undefined' !== typeof window){
      isDark =  window.site_dark_bg;
   }
   return isDark;
};
const getImageSrc = (image, isNextApp) => {

   if(isNextApp && image){
      return image.src;
   }
   return image;
};


const hexToRgb = (hex, opacity = 1) => {
   hex = hex.replace('#', '');

   let r = parseInt(hex.substring(0, 2), 16);
   let g = parseInt(hex.substring(2, 4), 16);
   let b = parseInt(hex.substring(4, 6), 16);

   return `rgba(${ r }, ${ g }, ${ b }, ${ opacity })`;
}

const countVisibleElements = (containerRef = null, gap = 2) => {
   if(containerRef.current) {
      const childrenArray = [...Array.from(containerRef.current.children)];
      const parentClientHeight = containerRef.current.clientHeight
      const parentClientWidth = containerRef.current.clientWidth
      let visibleIndex = 0

      const tempContainer = document.createElement('div');
      tempContainer.id = 'tempContainer'
      tempContainer.style.position = 'absolute'
      tempContainer.style.visibility = 'hidden'
      tempContainer.style.height = parentClientHeight + 'px'
      tempContainer.style.width = parentClientWidth + 'px'
      tempContainer.style.display = 'flex'
      tempContainer.style.gap = gap + 'px'
      tempContainer.style.flexWrap = 'wrap'
      document.body.appendChild(tempContainer)

      for(let index = 0; index < childrenArray.length; index++) {
         const childHeight = childrenArray[index].clientHeight
         const childWidth = childrenArray[index].clientWidth

         const tempChild = document.createElement('div');
         tempChild.style.width = childWidth + 'px';
         tempChild.style.height = childHeight + 'px';

         tempContainer.appendChild(tempChild)
         if(tempContainer.scrollHeight > parentClientHeight) {
            return visibleIndex
         }

         visibleIndex++
      }

      tempContainer.remove()
   }
};

const generateUniqueFileHash = async (file) => {
   const arrayBuffer = await file.arrayBuffer();

   // Hash the file content using SHA-256
   const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
   const hashArray = Array.from(new Uint8Array(hashBuffer));
   const fileHash = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

   const uniqueFileIdentifier = `${ fileHash }-${ Date.now() }`;
   return uniqueFileIdentifier;
}

const addRobotMetaTag = (content = 'noindex, nofollow') => {
   if(window.document.querySelector('meta[name=robots]')) return;
   const rorbotMeta = window.document.createElement('meta');
   rorbotMeta.name = 'robots';
   rorbotMeta.content = content;
   window.document.head.insertBefore(rorbotMeta, window.document.querySelector('meta[name=domainType]'));
}
const removeRobotMetaTag = () => {
   const rorbotMeta = window.document.querySelector('meta[name=robots]');
   if(rorbotMeta){
      window.document.head.removeChild(rorbotMeta);
   }
}

const setReferrerUrl = (pageInfo) => {
   if('undefined' === typeof window) return
   const referrer_url = {
      ...pageInfo,
      url: window.location.href,
   }
   window.referrer_url = referrer_url;

}
const replaceSiteUrlMemberPartWithBoldHtml = (text = '') => {
   let result = text;

   if(result.includes('mymember.')) {
      result = result.replaceAll('member.', '<span style="font-weight: bold;">member.</span>')
   }

   return result
}

const getFooterHealthTextStateCode = (siteInfoAgeVerificationLocation = {}) => {
   let result = null

   let stateCodeSegment = siteInfoAgeVerificationLocation?.code_segment || window.blockedAdditionalData?.additional_info?.site_info?.age_verification_location?.code_segment

   if(stateCodeSegment && ['AL', 'TX'].includes(stateCodeSegment)) {
      result = stateCodeSegment
   }

   return result
}

const portraitImageChecker = (file, src = '') => {
   return new Promise((resolve, reject) => {
      try {
         const tempImg = new Image();

         if(file) {
            const reader = new FileReader();
            reader.onload = () => {
               tempImg.src = reader.result;
            };
            reader.readAsDataURL(file);
         } else {
            tempImg.src = src;
         }
         tempImg.onload = () => {
            resolve(tempImg.naturalHeight > tempImg.naturalWidth);
         }
         tempImg.onerror = () => reject(new Error("Image failed to load"));
      } catch (error) {
         reject(error);
      }
   });
};

const validateImageResolution = (file, minWidth, minHeight, targetRatio) => {
   return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
         const img = new Image();
         img.onload = () => {
            const width = img.width;
            const height = img.height;
            const isValidResolution = width >= minWidth && height >= minHeight;
            if(!isValidResolution){
               reject('invalid_resolution');
            }
            if(targetRatio){
               const ratio =  img.height / img.width;
               const isValidRatio = Math.abs(ratio - targetRatio) < 0.09; // Allow small tolerance
               if(!isValidRatio) {
                  reject('invalid_ratio');
               }
            }
            resolve('ok');
         };
         img.onerror = () => reject('invalid_image_file');
         img.src = e.target.result;
      };

      reader.onerror = () => reject('failed_to_read');
      reader.readAsDataURL(file);
   });
}


const getDeviceType = () => {
   const ua = navigator.userAgent;

   if(/mobile/i.test(ua)) {
      return "mobile";
   } else if(/tablet/i.test(ua) || (window.innerWidth > 600 && window.innerWidth <= 1024)) {
      return "tablet";
   } else {
      return "desktop";
   }
}

const onUnavailableLivestreamPurchase = (streamData, id, bool = true) => {
   const isEndOnlineStream = (id !== 'scheduled' && streamData?.id !== id) || streamData.is_stream_offline;
   const isCanceledScheduledStream = 'scheduled' === id && !streamData.scheduled_livestream_date;
   const alreadyUnlocked = 'unlocked' === streamData?.stream_access_type;

   if(isEndOnlineStream || isCanceledScheduledStream || alreadyUnlocked){
      let text = 'You have already unlocked this livestream';
      if(isCanceledScheduledStream){
         text = 'Livestream has been canceled';
      }
      if(isEndOnlineStream){
         text = 'Livestream ended';
      }
      if(bool){
         toast.error(text);
      }
      return true;
   }
   return false;
}

const moreInfoProps = () => {

   const buttonProps = {
      textColor: 'action',
      backgroundColor: 'transparent',
      textSize: 'small',
      iconName: 'help',
      iconPosition: 'left',
      fontIconColor: 'action',
      fontIconSize: 'extraLarge',
      fontWeight: 'medium',
      textClassName: '!leading-[18px]',
      primaryColor: true,
      textMarginX: '2',
      // classNames: '!py-[10px] !px-[14px] !h-9 ',
   }

   // Example
   //
   // let btn = <>
   //    <Button
   //       classNames='!py-[10px] !px-[14px] !h-9 '
   //       {
   //          ...moreInfoProps()
   //       }
   //    />
   // </>

   return buttonProps

}

const sendGoogleAnalyticsPurchaseEvent = (siteInfo, data) => {
   if(!siteInfo?.gtag) return;
   if(!window.gtag) return;
   // let amount = Number(data.amount);
   // if(isNaN(amount) || 'number' !== typeof amount) return;
   // const name = data?.item_name || data?.name || '';
   // const ecommerceItemState = {
   //    membership: {
   //       item_category: 'Membership',
   //       item_name: name,
   //       item_id: data.id,
   //    },
   //    store: {
   //       item_category: 'Store item',
   //       item_name: name,
   //       item_id: data.id,
   //    },
   //    tip: {
   //       item_category: 'Tip',
   //       item_name: `Tip: ${ amount }$`,
   //    },
   //    video_unlock: {
   //       item_category: 'Video unlock',
   //       item_name: name,
   //       item_id: data.id,
   //    },
   //    photoset_unlock: {
   //       item_category: 'Photoset unlock',
   //       item_name: name,
   //       item_id: data.id,
   //    },
   //    livestream_access_unlock: {
   //       item_category: 'Livestream',
   //    },
   //    livestream_recorded_video_unlock: {
   //       item_category: 'Recorded unlock',
   //       item_name: name,
   //       item_id: data.id,
   //    },
   //    video_download: {
   //       item_category: 'Video download',
   //       item_name: name,
   //       item_id: data.id,
   //    },
   //    photoset_download: {
   //       item_category: 'Photoset download',
   //       item_name: name,
   //       item_id: data.id,
   //    },
   //    chat_video_unlock: {
   //       item_category: 'Chat unlock',
   //       item_name: 'Chat video unlock',
   //    },
   //    chat_voice_unlock: {
   //       item_category: 'Chat unlock',
   //       item_name: 'Chat voice unlock',
   //    },
   //    chat_photoset_unlock: {
   //       item_category: 'Chat unlock',
   //       item_name: 'Chat photo unlock',
   //    },
   //    chat_multiple_attachment_unlock: {
   //       item_category: 'Chat unlock',
   //       item_name: 'Multiple attachment',
   //    },
   //    ppm_text: {
   //       item_category: 'PPM',
   //       item_name: 'Chat text message',
   //    },
   //    ppm_photo: {
   //       item_category: 'PPM',
   //       item_name: 'Chat photo message',
   //    },
   //    ppm_voice: {
   //       item_category: 'PPM',
   //       item_name: 'Chat voice message',
   //    },
   //    wallet_top_up: {
   //       item_category: 'Wallet top up',
   //       item_name: 'Wallet top up',
   //    },
   // };

   // const itemState = ecommerceItemState?.[data.purchase_type];
   // if(!Boolean(itemState)) return;
   // const ecommerce = {
   //    transaction_id: data.transaction_id,
   //    value: +amount,
   //    shipping: data.shipping ? +data.shipping : 0,
   //    tax: 0,
   //    currency: "USD",
   //    items: [
   //       {
   //          ...itemState,
   //          price: +amount,
   //          quantity: 1,
   //       },
   //    ],
   // }
   // window.gtag('event', 'purchase', ecommerce);

   // console.log('gtag ecommerce => ', ecommerce)
}

const removeEmptyParagraphs = (html) => {
   const doc = new DOMParser().parseFromString(`<div>${ html }</div>`, 'text/html');
   const container = doc.body.firstChild;

   const isEmptyParagraph = (node) => {
      return (
         node.tagName === 'P' &&
        node.innerHTML.trim().toLowerCase() === '<br>'
      );
   };

   // Remove empty <p><br></p> from the start
   while(container.firstChild && container.firstChild.nodeType === Node.ELEMENT_NODE && isEmptyParagraph(container.firstChild)) {
      container.removeChild(container.firstChild);
   }

   // Remove empty <p><br></p> from the end
   while(container.lastChild && container.lastChild.nodeType === Node.ELEMENT_NODE && isEmptyParagraph(container.lastChild)) {
      container.removeChild(container.lastChild);
   }

   // return html;
   return container.innerHTML;
};

const isDrmTokenBasedLicenseIssuanceForMember = (memberUuid = '') => {
   return [
      'a34586f6375548bd0092fced48e39164', // Staging member UUID for test
      'ea001a22fa94c500f63b34e236088769', // secret...project -> mhbusiness900 member
   ].includes(memberUuid)
}

// This function checks site, and depending on this shows VR video uploading flow,
// VR checkbox of video and VR player
const isShowVrVideo = (siteUuid) => {
   if(isLocalhost() || window.location.href.includes('amstest')) {
      return true
   }

   const uuids = [
      'e049a82709704088982539ecf5dcc2d7', // sageartvr@yahoo.com
      '021e4a825f8f4d52b424a55b84a4373c', // toychloe@gmail.com
      '2af8c85889fe4148ac704041e862d7d4', // shaundam@gmail.com
      '3c2ca288fdf34e878b5f37ad3d3466a5', // billiestarcz@gmail.com
      '11e86c8ea8994cef9e29ee1935210623', // sabdeluxe81@gmail.com
      '5197bfb05130480c9a52bb8da986ee13', // mms-testing
      '7d22eb391b589e119f91db57ed077567', // cretrix

   ];
   return uuids.includes(siteUuid);
}

const getMemberUserState = (status) => {
   const state = {
      active: {
         name: 'Active',
         view_as: {
            color: 'text-green dark:text-green-dark',
            bg_color: 'bg-green-50 dark:bg-green-dark-50',
         },
      },
      cancelled: {
         name: 'Canceled',
         view_as: {
            color: 'text-red dark:text-red-dark',
            bg_color: 'bg-red-50 dark:bg-red-dark-50',
         },
      },
      expired: {
         name: 'Expired',
         view_as: {
            color: 'text-gray-600 dark:text-gray-dark-600',
            bg_color: 'bg-gray-50 dark:bg-gray-dark-50',
         },
      },
      free: {
         name: 'Complimentary',
         view_as: {
            color: 'text-blue dark:text-blue-dark',
            bg_color: 'bg-blue-50 dark:bg-blue-dark-50',
         },
      },
      guest: {
         name: 'Guest',
         view_as: {
            color: 'text-orange dark:text-orange-dark',
            bg_color: 'bg-orange-50 dark:bg-orange-dark-50',
         },
      },
      failed_rebill: {
         name: 'Failed rebill',
         view_as: {
            color: 'text-gray-600 dark:text-gray-dark-600',
            bg_color: 'bg-gray-50 dark:bg-gray-dark-50',
         },
      },
      visitor_with_age_verification: {
         name: 'With age verification required',
         view_as: {
            color: 'text-gray-600 dark:text-gray-dark-600',
            bg_color: 'bg-gray-50 dark:bg-gray-dark-50',
         },
      },
   };
   let result = state[status];
   if(!result){
      result = state.guest;
   }

   return result;
}


export {
   trigerExportCsvClick,
   formatApiErrors,
   copyText,
   getBase64FromImageFile,
   getObjectMd5,
   isMobileAndTablet,
   makeRandomString,
   downloadMediaFromUrl,
   getCountState,
   getImageFileHash,
   getVideoFileHash,
   makeTweetableUrl,
   insertTextMac,
   getCurrentPosition,
   addEmojiOnInput,
   switchShowEmojis,
   onWrongPriceLength,
   getBrowserName,
   getTopPercentage,
   makeFbShareUrl,
   makeSnapShareUrl,
   // makeShareSomeShareUrl,
   getSetDifference,
   iosCopyToClipboard,
   getProtocol,
   getLanguages,
   getCurrentLanguageByValue,
   setCookieValue,
   getAllowedVideoExtentions,
   onTranslteLanguage,
   upperCaseFirstLetter,
   encodeString,
   decodeString,
   toTitleCase,
   addDynamicCode,
   getDefaultNotificationSettings,
   getSiteDomain,
   getVariablesValue,
   getFixedSentences,
   isQuillEmpty,
   getProfileAccountState,
   parseUserAgent,
   getMemberTotalSpent,
   getMyListUrl,
   stripMetadata,
   quillUtils,
   onClickAddToCalendar,
   generateCalendarUrl,
   converDesriptionVarables,
   getUserStatusType,
   getPrimaryColor,
   isDarkSite,
   getImageSrc,
   hexToRgb,
   countVisibleElements,
   generateUniqueFileHash,
   setReferrerUrl,
   addRobotMetaTag,
   removeRobotMetaTag,
   replaceSiteUrlMemberPartWithBoldHtml,
   getFooterHealthTextStateCode,
   portraitImageChecker,
   validateImageResolution,
   getDeviceType,
   getAmazonPrefix,
   onUnavailableLivestreamPurchase,
   moreInfoProps,
   sendGoogleAnalyticsPurchaseEvent,
   removeEmptyParagraphs,
   isDrmTokenBasedLicenseIssuanceForMember,
   isShowVrVideo,
   getMemberUserState,
   getAllowedVrVideoQualityOptionExtentions,
};
